import RequestAbstract from "../abstract";

export default class PartnerHasCoins extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/partner-has-coins";
    }
}
